// extracted by mini-css-extract-plugin
export default {"stars":"starrating_stars__+KWCq","svg":"starrating_svg__H9FwH"};